import request from '@/utils/request';

export async function selAreaToTime(params) {
  return request.post('/api/bigdata/selAreaToTime', { ...params });
}

export async function selBaseInfoSubsidiary(params) {
  return request.post('/api/bigdata/selBaseInfoSubsidiary', { ...params });
}

export async function selRecordRemindSchemeByPage(params) {
  return request.post('/api/bigdata/selRecordRemindSchemeByPage', { ...params });
}

export async function selHarvestYield(params) {
  return request.post('/api/bigdata/selHarvestYield', { ...params });
}

export async function selBaseInfoAreaAndYield(params) {
  return request.post('/api/bigdata/selBaseInfoAreaAndYield', { ...params });
}

export async function selCategoryNum(params) {
  return request.post('/api/bigdata/selCategoryNum', { ...params });
}
export async function selCountPdmgCategoryTrendMJ(params) {
  return request.post('/api/bigdata/selCountPdmgCategoryTrendMJ', { ...params });
}
export async function selCountPdmgCategoryTrendCL(params) {
  return request.post('/api/bigdata/selCountPdmgCategoryTrendCL', { ...params });
}
export async function selectAllManageManufacturerListByGroup(params) {
  return request.post('/openapi/basic/manageManufacturer/selectAllManageManufacturerListByGroup/manage', { ...params });
}
export async function selManageManufacturerListByPage(params) {
  return request.post('/api/basic/manage/manufacturer/selManageManufacturerListByPage', { ...params });
}
export async function selectStatIndustryInfoIntegrationListByGroup(params) {
  return request.post('/openapi/dmp/statIndustryInfoIntegration/selectStatIndustryInfoIntegrationListByGroup/manage', { ...params });
}
export async function selStatIndustryInfoIntegrationListPage(params) {
  return request.post('/api/stat/statIndustryInfoIntegration/selStatIndustryInfoIntegrationListPage', { ...params });
}
